// extracted by mini-css-extract-plugin
export default {"signupDetailsForm":"SignupDetailsForm_signupDetailsForm__eOHz9","row":"SignupDetailsForm_row__fcboW","sumbitButton":"SignupDetailsForm_sumbitButton__u3ae+"};